import { Component, inject, OnInit, signal } from '@angular/core';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgOptimizedImage } from "@angular/common";
import { MessageService } from "../../services/helpers/message.service";
import { DashboardService } from "../../services/api/dashboard.service";
import { openAgreementDialog } from "../../components/agreement-dialog/agreement-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";

@Component({
  selector: 'app-footer',
  imports: [
    TranslateModule,
    SafeHtmlPipe
  ],
  templateUrl: './footer.component.html',
  styles: ``
})
export class FooterComponent implements OnInit {
  emailInfo = signal({
    link: 'mailto:info@t-crypto.uz',
    email: 'info@t-crypto.uz',
  });
  fullYear = signal<number>(2022);
  #message = inject(MessageService);
  #dashboard = inject(DashboardService);
  #dialog = inject(MatDialog);
  #translate = inject(TranslateService);


  ngOnInit(): void {
    const year = new Date().getFullYear();
    this.fullYear.set(year);
  }

  async getAgreementInfo(): Promise<void> {
    try {
      const res = await this.#dashboard.infoAgreement();

      if (res && res.success) {
        await this.openAgreement(res.result.data.agreementContent);
      }

      if (res && !res.success) {
        this.#message.showMessage(res.result.message ?? 'error', 'error');
      }


    } catch (err) {
      this.#message.showMessage('error', 'error');
    }
  }

  async openAgreement(data: string): Promise<void> {
    const agreement = await openAgreementDialog(this.#dialog, data, 'close');

    if (!agreement) {
      return;
    }
  }

  openEula(): void {
    const currentLang = this.#translate.currentLang || 'ru';

    const langMap: Record<string, string> = {
      ru: 'eula_ru.pdf',
      en: 'eula_en.pdf',
      uz: 'eula_ru.pdf'
    };

    const fileName = langMap[currentLang] || langMap['ru'];
    const filePath = `/docs/${fileName}`;

    window.open(filePath, '_blank');
  }
}
